createShareModel